module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "pdf"
    }
  }, [_c('hr'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "row"
    }
  }, [_c('img', {
    staticClass: "logo_leak logo",
    attrs: {
      "width": "200px",
      "src": _vm.logoUrl
    }
  }), _vm._v(" "), _c('h4', [_vm._v("nota informativa no.")]), _vm._v(" "), _c('div', {
    staticClass: "pdf__info"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Fecha: ")]), _vm._v(" " + _vm._s(_vm.desde) + " a " + _vm._s(_vm.hasta) + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Ducto: ")]), _vm._v(" " + _vm._s(_vm.site && _vm.site.section || '') + " ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Tramo: ")]), _vm._v(" " + _vm._s(_vm.site && _vm.site.sites || '') + " ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Vista satelital ")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.site) ? _c('img', {
    attrs: {
      "id": "img_map",
      "src": ("" + (_vm.site.map))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('custom-line-chart', {
    attrs: {
      "pdesde": _vm.desde,
      "phasta": _vm.hasta,
      "pducto": _vm.site && _vm.site.sectionId || 'ZZ',
      "pestacion": ("" + (_vm.site && _vm.site.sitesIds || '')),
      "cclick": _vm.click
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "imgChart"
    }
  }), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tableholder"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.site) ? _c('tbody', [_vm._l((_vm.site.events), function(r, key) {
    return _c('tr', {
      key: _vm.site.sites + '-' + key,
      attrs: {
        "id": "trw"
      }
    }, [_c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.fecha) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.km) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.lat) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.lng))]), _vm._v(" "), _c('td', {
      attrs: {
        "id": "tdc"
      }
    }, [_vm._v(" " + _vm._s(r.type === 1 ? 'Apertura' : 'Cierre'))])])
  }), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "trw-mp"
    }
  }, [_c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" Punto medio")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.middlePoint.km.toFixed(3)) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.middlePoint.lat.toFixed(5)) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  }, [_vm._v(" " + _vm._s(_vm.middlePoint.lng.toFixed(5)) + " ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "id": "tdc"
    }
  })])], 2) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" Para: ")]), _vm._v(" A quien corresponda ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "pdf__titles"
  }, [_vm._v(" De: ")]), _vm._v(" Ingeniería e Instalaciones S.A. de C.V. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    attrs: {
      "id": "header"
    }
  }, [_c('tr', {
    attrs: {
      "id": "trh"
    }
  }, [_c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Fecha Evento")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Kilometro")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Latitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Longitud")]), _vm._v(" "), _c('th', {
    staticClass: "title__td",
    attrs: {
      "id": "thh"
    }
  }, [_vm._v("Acción")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-195b8fc4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Historico/PdfDiv.vue
// module id = 1688
// module chunks = 6